import styled from 'styled-components'
import { cores } from '../../styles'

export const CardDetalhes = styled.div`
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.6);
`

export const DetalhesTitle = styled.h1`
  color: ${cores.corPrincipal};
  font-weight: bold;
  text-align: center;
`

export const ResponsiveDetalhesTitle = styled.h1`
  color: ${cores.corPrincipal};
  font-weight: bold;
`

export const ResponsiveTitleImageDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    height: 320px;
    border-radius: 8px;
    margin-top: 24px;
    margin-bottom: 16px;
  }
`

export const ResponsiveCardContent = styled.div`
  margin: 0 60px;
`
